export default __webpack_public_path__ + "static/media/ic_logo_white.f63afa1e.png";